module.exports = __webpack_public_path__ + "img/img-hero-01-caocao.f700171.png";


//////////////////
// WEBPACK FOOTER
// ./client/smsgz/assets/images/img-hero-01-caocao.png
// module id = /qby
// module chunks = 2